import { render, staticRenderFns } from "./MiddleMaskEditor.vue?vue&type=template&id=bb7f866a&scoped=true"
import script from "./MiddleMaskEditor.vue?vue&type=script&lang=js"
export * from "./MiddleMaskEditor.vue?vue&type=script&lang=js"
import style0 from "./MiddleMaskEditor.vue?vue&type=style&index=0&id=bb7f866a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7f866a",
  null
  
)

export default component.exports